import React, { useState } from 'react'
import OptionsButton from '../options-forms/OptionsButton';
import OptionsModal from './OptionsModal';


const StepOptions = (props) => {


   const {
      currentStepIndex,
      setCurrentStepIndex,
      setListData,
      listData,
      validateCurrentOptionForm,
      formState,
      setFormState,
      basketState,
      setBasketState,
      handleOnslid,
      openOptions,
      setOpenOptions
   } = props

   return (
      <div className='d-lg-none'>
         {/* <OptionsButton currentStepIndex={currentStepIndex} setOpen={setOpen} title='Options' /> */}
         <OptionsModal {...props} open={openOptions} setOpen={setOpenOptions} />
      </div>
   )

}
export default StepOptions